import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import { AuthContext } from '../navigation/AuthProvider';
import toast, { Toaster } from 'react-hot-toast';
import styled from 'styled-components';
import { useToast } from '../controller/ToastController';
import { useLocation } from 'react-router-dom';

import LoginController from '../controller/LoginController';

export const LoginContract = (oProps: any) => {
  const showToast = useToast();
  const location = useLocation();

  const queryString = location.search;
  const signupIdString: any = new URLSearchParams(queryString).get('signup_id');
  const signupId = parseInt(signupIdString, 10);
  const [termsLinkClick, setTermsLinkClick] = useState<boolean>(false);
  const [privacyLinkClicked, setPrivacyLinkClicked] = useState<boolean>(false);
  const [termsChecked, setTermsChecked] = useState<boolean>(false);
  const [privacyChecked, setPrivacyChecked] = useState<boolean>(false);

  const canvasImg = useRef<SignatureCanvas | null>(null);

  const [successSign, setSuccessSign] = React.useState<boolean>(false);

  const CanvasWrapper = styled.div`
    position: relative;
  `;
  const CanvasPlaceholder = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #999;
    font-weight: 400;
  `;

  // 약관확인 및 약관동의
  const handleCheckboxChange = (type: 'terms' | 'privacy') => {
    if ((type === 'terms' && !termsLinkClick) || (type === 'privacy' && !privacyLinkClicked)) {
      showToast(`약관 '보기'를 먼저 확인해주세요`, 'error');
      return;
    }

    if (type === 'terms') {
      setTermsChecked(!termsChecked);
    } else if (type === 'privacy') {
      setPrivacyChecked(!privacyChecked);
    }
  };
  const handleLinkClickTerms = () => {
    setTermsLinkClick(true);
    // handleCheckboxChange('terms');
  };
  const handleLinkClickPrivacy = () => {
    setPrivacyLinkClicked(true);
    // handleCheckboxChange('privacy');
  };

  const handleConfirm = async () => {
    if (canvasImg.current) {
      const isSignatureEmpty = canvasImg.current.isEmpty();

      if (!termsChecked || !privacyChecked) {
        showToast('약관을 모두 동의해주세요.', 'error');
      } else if (isSignatureEmpty) {
        showToast('서명을 해주세요.', 'error');
      } else {
        const imgData = canvasImg.current.getTrimmedCanvas().toDataURL('image/png');
        const blob = await fetch(imgData).then((res) => res.blob());
        const formData = new FormData();
        formData.append('file', blob);

        try {
          const oRes = await LoginController.upload(formData, signupId);
          const imageUrl = oRes.data.data.url_path;

          console.log('oRes', oRes);
          if (oRes.data.ok) {
            let signUpList = {
              signup_id: signupId,
              signup_url: imageUrl,
            };
            const oRes = await LoginController.signUp(signUpList);

            if (oRes.data.ok) {
              showToast('인증이 완료되었습니다. 로그인해주세요.');
              setSuccessSign(true);
              setTimeout(() => {
                window.location.href = 'https://knock-knock.ivid.kr/store/manager';
              }, 2000);
            } else {
              showToast(oRes.data.msg, 'error');
            }
          } else {
            showToast(oRes.data.msg, 'error');
          }

          console.log('서명 업로드 성공:');
        } catch (error) {
          console.error('서명 업로드 오류:');
        }
      }
    }
  };

  return (
    <Style>
      <div className="wrap">
        <div className="container">
          <Link to={'/'}>
            <img
              className="logo"
              src={`${process.env.PUBLIC_URL}/svg/ic_logo_black.svg`}
              alt="logo"
              width="100%"
              style={{
                maxWidth: '44px',
              }}
            />
          </Link>
          <h1>전자서명</h1>
          <h2>
            전자서명 문서 내용을 모두 확인 후,
            <br /> 전자서명을 진행해주세요.
          </h2>

          <div className="title">
            <h2>전자서명 문서 목록</h2>
          </div>
          <div className="pdfList">
            <p className="noticeMessage">
              반드시 약관을 읽고 체크(확인)하셔야 다음 단계로 진행됩니다.
            </p>
            <ul>
              <li>
                <img
                  className="logo"
                  src={`${process.env.PUBLIC_URL}/img/pdfImage.png`}
                  alt="logo"
                  width="100%"
                  style={{
                    maxWidth: '14px',
                  }}
                />
                <h2>
                  <strong className="noticeMessage box">필수</strong> 판매자 이용 약관
                </h2>
                <a
                  target="_blank"
                  onClick={handleLinkClickTerms}
                  href="https://prd-kk-storage.s3.ap-northeast-2.amazonaws.com/contract/%ED%8C%90%EB%A7%A4%EC%9E%90+%EC%9D%B4%EC%9A%A9+%EC%95%BD%EA%B4%80.pdf">
                  보기
                </a>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={termsChecked}
                  onChange={() => handleCheckboxChange('terms')}
                />
              </li>
              <li>
                <img
                  className="logo"
                  src={`${process.env.PUBLIC_URL}/img/pdfImage.png`}
                  alt="logo"
                  width="100%"
                  style={{
                    maxWidth: '14px',
                  }}
                />
                <h2>
                  <strong className="noticeMessage box">필수</strong> 판매자 개인정보 수집 및 이용
                  동의
                </h2>
                <a
                  target="_blank"
                  onClick={handleLinkClickPrivacy}
                  href="
                  https://prd-kk-storage.s3.ap-northeast-2.amazonaws.com/contract/%ED%8C%90%EB%A7%A4%EC%9E%90+%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4+%EC%88%98%EC%A7%91+%EB%B0%8F+%EC%9D%B4%EC%9A%A9+%EB%8F%99%EC%9D%98.pdf">
                  보기
                </a>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={privacyChecked}
                  onChange={() => handleCheckboxChange('privacy')}
                />
              </li>
            </ul>
          </div>
          <div className="title">
            <h2>약관동의 서명란</h2>
          </div>
          <p className="noticeMessage black">
            나는 가입하는 사업자의 대표자로서 위 약관을 충분히 읽고 확인했으며, 약관에 동의하여
            서명합니다.
          </p>
          <div className="canvasBox">
            <CanvasWrapper>
              <CanvasPlaceholder>여기에 서명을 해주세요.</CanvasPlaceholder>
              <SignatureCanvas
                ref={canvasImg}
                clearOnResize={false}
                canvasProps={{ className: 'sigCanvas' }}
              />
            </CanvasWrapper>
          </div>
          <p className="noticeMessage">
            *주의* 대리인 서명 금지, 대리인 서명으로 문제 발생 시 민형사상 책임을 묻습니다.
          </p>
          <button onClick={handleConfirm} className="successButton">
            확인
          </button>
        </div>
      </div>
      <Toaster />
    </Style>
  );
};

export const Style = styled.div`
  .wrap {
    width: 100%;
    height: 100%;
    background: #f8fafc;
  }
  .container {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    min-height: 100dvh;
    padding: 20px 4vw !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  ul,
  li,
  a {
    list-style: none;
  }
  h1 {
    margin: 24px 0 12px 0;
    font-size: 26px;
    font-weight: 700;
    color: #26282c;
  }
  h2 {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    color: #555555;
  }

  /* title */
  .title {
    width: 100%;
    margin: 20px 0 0px 0;
    padding: 8px 16px;
    border-radius: 5px;
    background: #ecf5f3;

    h2 {
      font-size: 16px;
    }
  }
  .noticeMessage {
    margin-top: 6px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #ff4a4a;
  }
  .noticeMessage.box {
    background: #ff4a4a;
    color: #fff;
    padding: 3px 6px;
    font-size: 10px;
    border-radius: 50px;
  }
  .noticeMessage.black {
    color: #000;
  }

  /* pdfList */
  .pdfList {
    width: 100%;
    ul {
      padding: 0;
    }
    li {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      padding: 8px;
      border-radius: 5px;
      border: 1px solid #4dd2ae;

      h2 {
        margin-left: 6px;
        font-size: 14px;
        font-weight: 400;
      }
      a {
        margin-left: auto;
        margin-right: 4px;
        color: #40977f;
        font-size: 14px;
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }

  /* checkbox */
  .checkbox {
    width: 18px;
    height: 18px;
    margin-left: 6px;
    cursor: pointer;
    accent-color: #40977f;
  }

  /* canvasBox */
  .canvasBox {
    width: 100%;
    margin-top: 24px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  .sigCanvas {
    width: 100%;
    height: 170px;
  }

  /* successBox */
  .successBox {
    margin-top: 20px;
    width: 100%;
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #4dd2ae;
    text-align: center;

    h2 {
      font-size: 14px;
      font-weight: 700;
      color: #4dd2ae;
    }
  }

  /* successButton */
  .successButton {
    width: 100%;
    margin: 32px 0 12px 0;
    padding: 12px 0;
    background: #4dd2ae;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    border-radius: 5px;
    text-align: center;
  }
`;
